// extracted by mini-css-extract-plugin
export default {"content":"StaffFormModal_content__t4b-a","contentFullScreen":"StaffFormModal_contentFullScreen__2Cx9X","title":"StaffFormModal_title__tXWRq","body":"StaffFormModal_body__eaVmG"};